import { TextInput } from 'components/textInput/TextInput'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface TargetListSearchInterface {
    onSearchInput: (e: React.ChangeEvent<HTMLInputElement>) => void
    searchValue: string
    searchIcon?: JSX.Element
    searchIconPos?: 'left' | 'right'
    searchPlaceholder?: string
}

export const TargetListSearch = ({
    onSearchInput,
    searchValue,
    searchIcon,
    searchIconPos,
    searchPlaceholder
}: TargetListSearchInterface) => {
    const { t } = useTranslation()

    return (
        <TextInput
            placeholder={searchPlaceholder || t('targetList.searchPlaceholder')}
            onChange={onSearchInput}
            value={searchValue}
            aria-label="search-input"
            id="client-list-search"
            className="target-list--search-input"
            icon={searchIcon}
            iconPos={searchIconPos}
            validation={!!searchIcon}
        />
    )
}
